import { Input, InputProps } from '@/components/ui/input'
import { formatCNPJ } from '@/utils/format'
import { forwardRef } from 'react'

type CNPJInputProps = Omit<InputProps, 'value' | 'onChange'> & {
  value: string
  onChange: (value: string) => void
}

const CNPJInput = forwardRef<HTMLInputElement, CNPJInputProps>(({ value, onChange, ...rest }, ref) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatCNPJ(e.target.value)
    onChange(formatted)
  }

  return (
    <Input
      ref={ref}
      {...rest}
      type="text"
      inputMode="numeric"
      pattern="\d{2}\.\d{3}\.\d{3}/\d{4}-\d{2}"
      placeholder="00.000.000/0000-00"
      value={value}
      onChange={handleChange}
      className="bg-input text-foreground max-w-sm"
    />
  )
})

export default CNPJInput
